import { css } from 'linaria';
import { styled } from 'linaria/react';

export namespace Container {
  export const ReviewRatingContent = styled.div`
    display: flex;
  `;
}

export namespace Styles {
  export const authorBlock = css`
    display: flex;
    flex-direction: column;
  `;

  export const useDuration = css`
    margin-top: var(--space-35);
  `;

  export const firstRow = css``;

  export const authorContainer = css`
    display: flex;
    align-items: center;
  `;

  export const personTitle = css`
    margin-inline-start: 12px;
  `;

  export const ratingWrapper = css`
    display: flex;
    align-items: center;
  `;

  export const variantStringWrapper = css`
    margin-top: calc(0px - var(--space-150));
  `;

  export const createdDate = css`
    margin-top: var(--space-25);
    margin-inline-start: var(--space-150);
  `;

  export const textRow = css`
    display: flex;
  `;

  export const textRowProsCons = css`
    display: flex;
    flex-flow: row wrap;
  `;

  export const prosConsLabel = css`
    flex-shrink: 0;
    padding-right: 4px;
  `;

  export const prosConsContent = css`
    display: flex;
    flex-grow: 1;
    flex-shrink: 0;
    max-width: 100%;
    margin: 0;
  `;

  export const likeDislikeGroupWrapper = css`
    margin-top: var(--space-50);
  `;

  export const reviewAdditionalInfoWrapper = css`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: var(--space-150);
  `;
}
